module.exports = __webpack_public_path__ + "img/Kamohara-Tsutomu.65a93c5d.jpg";